// Stripe.js
export const PROD_STRIPE_JS_URL = 'https://js.stripe.com/v3/';
export const PREPROD_STRIPE_JS_URL = 'https://qa-js.stripe.com/v3/';
export const QA_STRIPE_JS_URL = 'https://qa-js.stripe.com/v3/';

// Stripe.js publishable key
export const PROD_STRIPE_JS_PUBLISHABLE_KEY =
  'pk_live_nkuGmDxzIqsxLJBvO7cqeUli';
export const DEVBOX_STRIPE_JS_PUBLISHABLE_KEY =
  'pk_test_mVLtZv4nqxZtGK7XmGzzAdti ';
